export default [
  {
    id: 2,
    name: 'Аптеки',
  },
  {
    id: 1,
    name: 'Продукты',
  },
  {
    id: 13,
    name: 'Товары для дома',
  },
  {
    id: 8,
    name: 'Детские товары',
  },
  {
    id: 7,
    name: 'Одежда и обувь',
  },
  {
    id: 3,
    name: 'Красота и здоровье',
  },
  {
    id: 10,
    name: 'Спорт и туризм',
  },
  {
    id: 4,
    name: 'Театры и музеи',
  },
  {
    id: 6,
    name: 'Кафе и рестораны',
  },
  {
    id: 9,
    name: 'Развлечения и досуг',
  },
  {
    id: 11,
    name: 'Услуги населению',
  },
  {
    id: 12,
    name: 'Ювелирные изделия',
  },
  {
    id: 14,
    name: 'АЗС',
  },
  {
    id: 16,
    name: 'Автовокзал',
  },
  {
    id: 15,
    name: 'Прочее',
  },
];
